import { CustomDxpWindow } from "./custom.window";

declare let window: CustomDxpWindow;

const dxpDataLayerToggleVerification = () => {
  return !!window?.dxpDataLayer;
};

export default dxpDataLayerToggleVerification;
